import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';

import {
  AI_COLORS,
  RESULT_TABLE_MAX_HEIGHT,
  RESULT_TABLE_ROWS_PER_PAGE,
  RESULT_TABLE_ROWS_PER_PAGE_OPTIONS
} from '../aiAnalyticsConstants';
import { columnName } from '../services/aiDataUtils';
import { formatCellValue } from '../services/aiFormatters';

export default function SqlResultTable({ columns, rows, footerLeft }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(RESULT_TABLE_ROWS_PER_PAGE);

  if (!columns || !rows || rows.length === 0) {
    return null;
  }

  const pageCount = Math.max(1, Math.ceil(rows.length / rowsPerPage));
  const safePage = Math.min(page, pageCount - 1);
  const start = safePage * rowsPerPage;
  const pageRows = rows.slice(start, start + rowsPerPage);

  function handleChangePage(_event, nextPage) {
    setPage(nextPage);
  }

  function handleChangeRowsPerPage(event) {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }

  return (
    <Box>
      <TableContainer component={Paper} sx={{ maxHeight: RESULT_TABLE_MAX_HEIGHT, mt: 1 }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map((col, i) => (
                <TableCell key={i} sx={{ fontWeight: 'bold', backgroundColor: AI_COLORS.surfaceMuted }}>
                  {columnName(col, i)}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {pageRows.map((row, rowIdx) => {
              const values = Array.isArray(row) ? row : columns.map((col, colIdx) => row[columnName(col, colIdx)]);
              return (
                <TableRow key={start + rowIdx} hover>
                  {values.map((cell, cellIdx) => (
                    <TableCell key={cellIdx}>{formatCellValue(cell)}</TableCell>
                  ))}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, flexWrap: 'wrap' }}>
        <Box sx={{ flex: 1, minWidth: 0 }}>{footerLeft}</Box>
        <TablePagination
          component="div"
          count={rows.length}
          page={safePage}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={RESULT_TABLE_ROWS_PER_PAGE_OPTIONS}
          sx={{ flexShrink: 0 }}
        />
      </Box>
    </Box>
  );
}
